import React, { Fragment } from 'react'
import Tilt from 'react-parallax-tilt'

import ThemeMenuThree from '../../components/header/ThemeMenuThree'
import ThemeBannerThree from '../../components/theme-banner/ThemeBannerThree'
import BlockStyleSeven from '../../components/block/BlockStyleSeven'
import FeatureFive from '../../components/feature/FeatureFive'
import BlockStyleTen from '../../components/block/BlockStyleTen'
import BlockStyleEight from '../../components/block/BlockStyleEight'
import PricingTab from '../../components/price/PricingTab'
import FeedbackThree from '../../components/testimonial/FeedbackThree'
import NewsletterTwo from '../../components/call-to-action/NewsletterTwo'
import FooterThree from '../../components/footer/FooterThree'

const CyberSecurity = () => {
  return (
    <Fragment>
      <div className="main-page-wrapper">

        <ThemeMenuThree />
        <ThemeBannerThree />

        <section className="about-codam bg-shape-3c pt-40 pb-105 pt-lg-60 pb-lg-10">
          <img className="about-shape-3c shape-1b d-none d-xl-inline-block" src="assets/img/shape/star-3b.svg" alt="배경 도형" />
          <img className="about-shape-3c shape-2b d-none d-md-inline-block" src="assets/img/shape/star-4b.svg" alt="배경 도형" />
          <img className="about-shape-3c shape-3b d-none d-lg-inline-block" src="assets/img/shape/star-4b.svg" alt="배경 도형" />
          <img className="about-shape-3c shape-4b" src="assets/img/shape/star-7c.svg" alt="배경 도형" />
          <img className="about-shape-3c shape-5b d-none d-xl-inline-block" src="assets/img/shape/star-4b.svg " alt="배경 도형" />
          <div className="container">
            <div className="row gx-4 gx-xxl-5 align-items-center">
              <div className="col-lg-6" data-aos="fade-right" data-aos-delay={100}>
                <div data-tilt className="about-img-wrapper-three text-lg-end position-relative mb-45">
                  <Tilt>
                    <img className="main-img" src="assets/img/about/ilus-1c.svg" alt="보안 시스템 일러스트" />
                  </Tilt>
                </div>
              </div>
              <div className="col-lg-6" data-aos="fade-left" data-aos-delay={100}>
                <BlockStyleSeven />
              </div>
            </div>
          </div>
        </section>

        <section className="gradient-bg our-services service-bg-three pt-95 pb-55 pt-lg-55 pb-lg-15">
          <img className="service-shape-3c" src="assets/img/shape/line-round-6b.svg" alt="배경 도형" />
          <div className="container">
            <div className="row gx-4 gx-xxl-5 align-items-center justify-content-center">
              <div className="col-xl-5 col-lg-6 col-md-8">
                <div className="section-title text-center mb-55">
                  <h2 className="sect-title mb-25" data-aos="fade-up">체계적인 보안 서비스</h2>
                  <p data-aos="fade-up" data-aos-delay={100}>개발 단계부터 운영까지 기업의 전 IT 자산을 보호하는 종합 보안 솔루션을 제공합니다.</p>
                </div>
              </div>
            </div>
            <FeatureFive />
          </div>
        </section>

        <section className="teachy-work work-bg-three pt-150 pb-30 pt-lg-50 pb-lg-20">
          <img className="work-shape-c shape-one" src="assets/img/shape/star-7c.svg" alt="배경 도형" />
          <img className="work-shape-c shape-two" src="assets/img/shape/star-7c.svg" alt="배경 도형" />
          <img className="work-shape-c shape-three" src="assets/img/shape/star-8c.svg" alt="배경 도형" />
          <img className="work-shape-c shape-four" src="assets/img/shape/star-8c.svg" alt="배경 도형" />
          <div className="container">
            <div className="row gx-4 gx-xxl-5 align-items-center pb-30">
              <div className="col-lg-6">
                <div data-tilt className="feature-img-wrapper mb-45" data-aos="fade-up">
                  <Tilt>
                    <img src="assets/img/ilustration/ilus-01.svg" alt="접근 제어 시스템 일러스트" />
                  </Tilt>
                </div>
              </div>
              <div className="col-lg-6 order-lg-first">
                <BlockStyleTen />
              </div>
            </div>
            <div className="row gx-4 gx-xxl-5 align-items-center pt-75 pt-lg-55">
              <div className="col-lg-6">
                <div className="feature-img-wrapper mb-45" data-aos="fade-up">
                  <Tilt>
                    <img src="assets/img/ilustration/ilus-02.svg" alt="데이터 보호 솔루션 일러스트" />
                  </Tilt>
                </div>
              </div>
              <div className="col-lg-6">
                <BlockStyleEight />
              </div>
            </div>
          </div>
        </section>

        <section className="codam-security pt-75 pb-150 pt-lg-55 pb-lg-60">
          <div className="container">
            <div className="row gx-4 gx-xxl-5 justify-content-center">
              <div className="col-lg-6 col-md-8">
                <div className="section-title text-center mb-55">
                  <h6 className="sub-title-two mb-20">통합 보안 아키텍처</h6>
                  <h3 className="sect-title" data-aos="fade-up">기업 전체 IT 자산을 보호하는 통합 보안 체계</h3>
                </div>
              </div>
            </div>
            <div className="row gx-4 gx-xxl-5">
              <div className="col-lg-12">
                <div className="ilustration-wrapper" data-aos="zoom-in">
                  <img className="w-100" src="assets/img/ilustration/ilus-03.svg" alt="통합 보안 아키텍처 일러스트" />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="codam-price">
          <div className="bg-wrapper-one">
            <div className="container">
              <div className="row gx-4 gx-xxl-5 align-items-center justify-content-center">
                <div className="col-xl-12">
                  <div className="section-title text-center mb-40">
                    <h6 className="sub-title-two mb-20">보안 서비스 요금</h6>
                    <h3 className="sect-title" data-aos="fade-up">기업 규모에 맞는 보안 솔루션</h3>
                  </div>
                </div>
              </div>
              <PricingTab />
            </div>
          </div>
        </section>

        <section className="client-feedback feedback-three pt-145 pb-115 pt-lg-60 pb-lg-60">
          <div className="container">
            <div className="row gx-4 gx-xxl-5">
              <div className="col-lg-12">
                <div className="section-title text-center mb-55">
                  <h6 className="sub-title-two mb-20" data-aos="fade-up">고객 후기</h6>
                  <h2 className="sect-title" data-aos="fade-up" data-aos-delay={100}>보안 서비스를 경험한 고객사의 이야기</h2>
                </div>
              </div>
            </div>
            <FeedbackThree />
          </div>
        </section>

        <NewsletterTwo />
        <FooterThree />
      </div>
    </Fragment>
  )
}

export default CyberSecurity
